import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { shouldShowFullscreenBanner, setHideBanner } from '../../common/cookie';
import { FullscreenBannerContent } from './FullscreenBannerContent/FullscreenBannerContent';
import { jsx as _jsx } from "react/jsx-runtime";
export var FullscreenBanner = function FullscreenBanner(_ref) {
  var url = _ref.url,
    caShowBanner = _ref.caShowBanner,
    caClickOnBanner = _ref.caClickOnBanner,
    caCloseBanner = _ref.caCloseBanner;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  React.useEffect(function () {
    if (shouldShowFullscreenBanner()) {
      setOpen(true);
      caShowBanner();
      setHideBanner();
    }
  }, []);
  var closeBanner = React.useCallback(function () {
    setOpen(false);
    caCloseBanner();
  }, []);
  var handleAccept = React.useCallback(function () {
    setOpen(false);
    caClickOnBanner();
  }, []);
  return open ? /*#__PURE__*/_jsx(FullscreenBannerContent, {
    url: url,
    handleAccept: handleAccept,
    closeBanner: closeBanner
  }) : null;
};